





























import { Vue } from "vue-property-decorator";
import Common from "@/mixins/common";

export default Vue.extend({
  name: "ChooseInvestUser",
  mixins: [Common],
  props: {
    title: { type: String, default: "" },
    desc : { type: String, default: "" },
    width: { type: String, default: "520px" },
  },

  data() {
    return {
      visible : false,
      loading : false,
      selected: "",
      data    : [],
    }
  },

  methods: {
    async list() {
      const status = 1
      const res = await this.$store.dispatch("invest_team/list", { status });
      if (res.Code == 200) {
        this.data = res.Data.data
      }
    },
    ok() {
      if (this.selected != "") {
        this.$emit("ok", this.selected)
      }
    },
    choose(id: string) {
      if (this.selected == id) {
        this.selected = ""
      } else this.selected = id
    },
    close() {
      this.visible = false
      this.loading = false
    },
  },
  watch: {
    visible(bool: boolean) {
      if (bool) this.list()
      else this.selected = ""
    }
  }
})

